import React, { useEffect, useState } from 'react';

import moment from 'moment';
import { Input } from 'v3/components';

const InputCellEditor = (props) => {
  const { value, inputType, stopEditing, onValueChange } = props;

  const [val, setVal] = useState('');

  useEffect(() => {
    if (inputType !== 'date') {
      setVal(value ?? '');
      return;
    }

    if (!value) {
      setVal('');
      return;
    }

    const parsedDate = moment(
      value,
      [
        'YYYY-MM-DDTHH:mm',
        'YYYY-MM-DD HH:mm:ss',
        'DD/MM/YYYY HH:mm',
      ],
      true,
    );

    if (parsedDate.isValid()) {
      setVal(parsedDate.format('YYYY-MM-DDTHH:mm'));
    } else {
      setVal('');
    }
  }, [value, inputType]);

  const handleChange = (e) => {
    const newValue = e.target.value;

    setVal(newValue);

    if (inputType === 'date') {
      onValueChange(
        newValue
          ? moment(newValue, 'YYYY-MM-DDTHH:mm').format('DD/MM/YYYY HH:mm')
          : null
      );
    } else {
      onValueChange(newValue);
    }
  };

  return (
    <Input
      type={inputType === 'date' ? 'datetime-local' : 'text'}
      value={val}
      onChange={handleChange}
      onBlur={() => stopEditing()}
      autoFocus
    />
  );
};

export default InputCellEditor;
